import { useState } from "react";
import { resetPassword, confirmResetPassword } from "aws-amplify/auth";
import PasswordInputValidation from "../PasswordInputValidation/PasswordInputValidation";

export const ForgotPassword = ({ switchToLogin }) => {
  const [email, setEmail] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSendCode = async (e) => {
    e.preventDefault();
    try {
      await resetPassword({ username: email });
      setCodeSent(true);
      setMessage("Verification code sent to your email.");
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to send code. Please try again.");
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    try {
      await confirmResetPassword({
        username: email,
        confirmationCode,
        newPassword,
      });
      setMessage("Password reset successful. You can now log in.");
      setError("");
      setTimeout(switchToLogin, 2000);
    } catch (err) {
      console.error(err);
      setError("Failed to reset password. Please check the code.");
    }
  };

  return (
    <div className="ForgotPassword">
      <h3>Forgot Password</h3>
      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}

      {!codeSent ? (
        <form onSubmit={handleSendCode}>
          <input
            type="email"
            placeholder="Enter your email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit">Send Verification Code</button>
        </form>
      ) : (
        <form onSubmit={handleConfirmReset}>
          <input
            type="text"
            placeholder="Verification Code"
            required
            value={confirmationCode}
            onChange={(e) => setConfirmationCode(e.target.value)}
          />
          <PasswordInputValidation
            name="newPassword"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <button type="submit">Reset Password</button>
        </form>
      )}
    </div>
  );
};
